/**
 * Taiwan Bank Data
 * Array of [code, name] pairs for Taiwanese financial institutions
 */

const banks = [
  ['600', '農金資訊股份有限公司'],
  ['952', '財團法人農漁會南區資訊中心'],
  ['997', '中華民國信用合作社聯合社南區聯合資訊處理'],
  ['000', '中央銀行國庫局'],
  ['004', '臺灣銀行'],
  ['005', '臺灣土地銀行'],
  ['006', '合作金庫商業銀行'],
  ['007', '第一商業銀行'],
  ['008', '華南商業銀行'],
  ['009', '彰化商業銀行'],
  ['011', '上海商業儲蓄銀行'],
  ['012', '台北富邦商業銀行'],
  ['013', '國泰世華商業銀行'],
  ['016', '高雄銀行'],
  ['017', '兆豐國際商業銀行'],
  ['018', '全國農業金庫'],
  ['021', '花旗（台灣）商業銀行'],
  ['048', '王道商業銀行'],
  ['050', '臺灣中小企業銀行'],
  ['052', '渣打國際商業銀行'],
  ['053', '台中商業銀行'],
  ['054', '京城商業銀行'],
  ['081', '匯豐（台灣）商業銀行'],
  ['101', '瑞興商業銀行'],
  ['102', '華泰商業銀行'],
  ['103', '臺灣新光商業銀行'],
  ['108', '陽信商業銀行'],
  ['118', '板信商業銀行'],
  ['147', '三信商業銀行'],
  ['803', '聯邦商業銀行'],
  ['805', '遠東國際商業銀行'],
  ['806', '元大商業銀行'],
  ['807', '永豐商業銀行'],
  ['808', '玉山商業銀行'],
  ['809', '凱基商業銀行'],
  ['810', '星展（台灣）商業銀行'],
  ['812', '台新國際商業銀行'],
  ['816', '安泰商業銀行'],
  ['822', '中國信託商業銀行'],
  ['823', '將來商業銀行'],
  ['824', '連線商業銀行'],
  ['826', '樂天國際商業銀行'],
  ['114', '基隆第一信用合作社'],
  ['115', '基隆市第二信用合作社'],
  ['119', '淡水第一信用合作社'],
  ['130', '新竹第一信用合作社'],
  ['132', '新竹第三信用合作社'],
  ['146', '台中市第二信用合作社'],
  ['162', '彰化第六信用合作社'],
  ['204', '高雄市第三信用合作社'],
  ['215', '花蓮第一信用合作社'],
  ['216', '花蓮第二信用合作社'],
  ['104', '台北市第五信用合作社'],
  ['120', '新北市淡水信用合作社'],
  ['124', '宜蘭信用合作社'],
  ['127', '桃園信用合作社'],
  ['158', '彰化第一信用合作社'],
  ['161', '彰化第五信用合作社'],
  ['163', '彰化第十信用合作社'],
  ['165', '彰化縣鹿港信用合作社'],
  ['178', '嘉義市第三信用合作社'],
  ['188', '台南第三信用合作社'],
  ['222', '澎湖縣第一信用合作社'],
  ['223', '澎湖第二信用合作社'],
  ['224', '金門縣信用合作社'],
  ['501', '宜蘭縣蘇澳區漁會（農金資訊所屬會員）'],
  ['502', '宜蘭縣頭城區漁會（農金資訊所屬會員）'],
  ['506', '桃園區漁會（農金資訊所屬會員）'],
  ['507', '新竹區漁會（農金資訊所屬會員）'],
  ['508', '通苑區漁會（農金資訊所屬會員）'],
  ['510', '南龍區漁會（農金資訊所屬會員）'],
  ['511', '彰化區漁會（農金資訊所屬會員）'],
  ['513', '新北市瑞芳區漁會（農金資訊所屬會員）'],
  ['514', '萬里區漁會（農金資訊所屬會員）'],
  ['516', '基隆區漁會（農金資訊所屬會員）'],
  ['512', '南農中心所屬會員'],
  ['515', '南農中心所屬會員'],
  ['517', '南農中心所屬會員'],
  ['518', '南農中心所屬會員'],
  ['520', '南農中心所屬會員'],
  ['521', '南農中心所屬會員'],
  ['523', '南農中心所屬會員'],
  ['524', '南農中心所屬會員'],
  ['525', '南農中心所屬會員'],
  ['526', '南農中心所屬會員'],
  ['519', '新化區農會（農金資訊所屬會員）'],
  ['538', '宜蘭市農會（農金資訊所屬會員）'],
  ['541', '白河區農會（農金資訊所屬會員）'],
  ['542', '麻豆區農會（農金資訊所屬會員）'],
  ['547', '後壁區農會（農金資訊所屬會員）'],
  ['549', '下營區農會（農金資訊所屬會員）'],
  ['551', '官田區農會（農金資訊所屬會員）'],
  ['552', '大內區農會（農金資訊所屬會員）'],
  ['556', '學甲區農會（農金資訊所屬會員）'],
  ['557', '新市區農會（農金資訊所屬會員）'],
  ['558', '安定區農會（農金資訊所屬會員）'],
  ['559', '山上區農會（農金資訊所屬會員）'],
  ['561', '左鎮區農會（農金資訊所屬會員）'],
  ['562', '仁德區農會（農金資訊所屬會員）'],
  ['564', '關廟區農會（農金資訊所屬會員）'],
  ['565', '龍崎區農會（農金資訊所屬會員）'],
  ['567', '南化區農會（農金資訊所屬會員）'],
  ['568', '七股區農會（農金資訊所屬會員）'],
  ['570', '南投市農會（農金資訊所屬會員）'],
  ['573', '埔里鎮農會（農金資訊所屬會員）'],
  ['574', '竹山鎮農會（農金資訊所屬會員）'],
  ['575', '中寮鄉農會（農金資訊所屬會員）'],
  ['577', '魚池鄉農會（農金資訊所屬會員）'],
  ['578', '水里鄉農會（農金資訊所屬會員）'],
  ['579', '國姓鄉農會（農金資訊所屬會員）'],
  ['580', '鹿谷鄉農會（農金資訊所屬會員）'],
  ['581', '信義鄉農會（農金資訊所屬會員）'],
  ['582', '仁愛鄉農會（農金資訊所屬會員）'],
  ['583', '東山區農會（農金資訊所屬會員）'],
  ['585', '頭城鎮農會（農金資訊所屬會員）'],
  ['586', '羅東鎮農會（農金資訊所屬會員）'],
  ['587', '礁溪鄉農會（農金資訊所屬會員）'],
  ['588', '壯圍鄉農會（農金資訊所屬會員）'],
  ['589', '員山鄉農會（農金資訊所屬會員）'],
  ['596', '五結鄉農會（農金資訊所屬會員）'],
  ['598', '蘇澳地區農會（農金資訊所屬會員）'],
  ['599', '三星地區農會（農金資訊所屬會員）'],
  ['602', '中華民國農會中壢辦事處信用部（農金資訊所'],
  ['605', '高雄市高雄地區農會（農金資訊所屬會員）'],
  ['615', '基隆市農會（農金資訊所屬會員）'],
  ['625', '臺中市臺中地區農會（農金資訊所屬會員）'],
  ['628', '鹿港鎮農會（農金資訊所屬會員）'],
  ['629', '和美鎮農會（農金資訊所屬會員）'],
  ['631', '溪湖鎮農會（農金資訊所屬會員）'],
  ['632', '田中鎮農會（農金資訊所屬會員）'],
  ['633', '北斗鎮農會（農金資訊所屬會員）'],
  ['635', '線西鄉農會（農金資訊所屬會員）'],
  ['636', '伸港鄉農會（農金資訊所屬會員）'],
  ['638', '花壇鄉農會（農金資訊所屬會員）'],
  ['639', '大村鄉農會（農金資訊所屬會員）'],
  ['642', '社頭鄉農會（農金資訊所屬會員）'],
  ['643', '二水鄉農會（農金資訊所屬會員）'],
  ['646', '大城鄉農會（農金資訊所屬會員）'],
  ['647', '溪州鄉農會（農金資訊所屬會員）'],
  ['649', '埔鹽鄉農會（農金資訊所屬會員）'],
  ['650', '福興鄉農會（農金資訊所屬會員）'],
  ['651', '彰化市農會（農金資訊所屬會員）'],
  ['683', '北港鎮農會（農金資訊所屬會員）'],
  ['685', '土庫鎮農會（農金資訊所屬會員）'],
  ['693', '東勢鄉農會（農金資訊所屬會員）'],
  ['696', '水林鄉農會（農金資訊所屬會員）'],
  ['697', '元長鄉農會（農金資訊所屬會員）'],
  ['698', '麥寮鄉農會（農金資訊所屬會員）'],
  ['699', '林內鄉農會（農金資訊所屬會員）'],
  ['749', '內埔地區農會（農金資訊所屬會員）'],
  ['762', '大溪區農會（農金資訊所屬會員）'],
  ['763', '桃園區農會（農金資訊所屬會員）'],
  ['764', '平鎮區農會（農金資訊所屬會員）'],
  ['765', '楊梅區農會（農金資訊所屬會員）'],
  ['766', '大園區農會（農金資訊所屬會員）'],
  ['767', '蘆竹區農會（農金資訊所屬會員）'],
  ['768', '龜山區農會（農金資訊所屬會員）'],
  ['769', '八德區農會（農金資訊所屬會員）'],
  ['770', '新屋區農會（農金資訊所屬會員）'],
  ['771', '龍潭區農會（農金資訊所屬會員）'],
  ['772', '復興區農會（農金資訊所屬會員）'],
  ['773', '觀音區農會（農金資訊所屬會員）'],
  ['775', '土城區農會（農金資訊所屬會員）'],
  ['776', '三重區農會（農金資訊所屬會員）'],
  ['777', '中和地區農會（農金資訊所屬會員）'],
  ['778', '淡水區農會（農金資訊所屬會員）'],
  ['779', '樹林區農會（農金資訊所屬會員）'],
  ['780', '鶯歌區農會（農金資訊所屬會員）'],
  ['781', '三峽區農會（農金資訊所屬會員）'],
  ['785', '蘆洲區農會（農金資訊所屬會員）'],
  ['786', '五股區農會（農金資訊所屬會員）'],
  ['787', '林口區農會（農金資訊所屬會員）'],
  ['788', '泰山區農會（農金資訊所屬會員）'],
  ['789', '坪林區農會（農金資訊所屬會員）'],
  ['790', '八里區農會（農金資訊所屬會員）'],
  ['791', '金山地區農會（農金資訊所屬會員）'],
  ['792', '瑞芳地區農會（農金資訊所屬會員）'],
  ['793', '新店地區農會（農金資訊所屬會員）'],
  ['795', '深坑區農會（農金資訊所屬會員）'],
  ['796', '石碇區農會（農金資訊所屬會員）'],
  ['797', '平溪區農會（農金資訊所屬會員）'],
  ['798', '石門區農會（農金資訊所屬會員）'],
  ['799', '三芝區農會（農金資訊所屬會員）'],
  ['860', '中埔鄉農會（農金資訊所屬會員）'],
  ['866', '阿里山鄉農會（農金資訊所屬會員）'],
  ['868', '東勢區農會（農金資訊所屬會員）'],
  ['869', '清水區農會（農金資訊所屬會員）'],
  ['870', '梧棲區農會（農金資訊所屬會員）'],
  ['871', '大甲區農會（農金資訊所屬會員）'],
  ['872', '沙鹿區農會（農金資訊所屬會員）'],
  ['874', '霧峰區農會（農金資訊所屬會員）'],
  ['875', '太平區農會（農金資訊所屬會員）'],
  ['876', '烏日區農會（農金資訊所屬會員）'],
  ['877', '后里區農會（農金資訊所屬會員）'],
  ['878', '大雅區農會（農金資訊所屬會員）'],
  ['879', '潭子區農會（農金資訊所屬會員）'],
  ['880', '石岡區農會（農金資訊所屬會員）'],
  ['881', '新社區農會（農金資訊所屬會員）'],
  ['882', '大肚區農會（農金資訊所屬會員）'],
  ['883', '外埔區農會（農金資訊所屬會員）'],
  ['884', '大安區農會（農金資訊所屬會員）'],
  ['885', '龍井區農會（農金資訊所屬會員）'],
  ['886', '和平區農會（農金資訊所屬會員）'],
  ['891', '花蓮市農會（農金資訊所屬會員）'],
  ['895', '瑞穗鄉農會（農金資訊所屬會員）'],
  ['896', '玉溪地區農會（農金資訊所屬會員）'],
  ['897', '鳳榮地區農會（農金資訊所屬會員）'],
  ['898', '光豐地區農會（農金資訊所屬會員）'],
  ['901', '大里區農會（農金資訊所屬會員）'],
  ['902', '苗栗市農會（農金資訊所屬會員）'],
  ['903', '汐止區農會（農金資訊所屬會員）'],
  ['904', '新莊區農會（農金資訊所屬會員）'],
  ['906', '頭份市農會（農金資訊所屬會員）'],
  ['907', '竹南鎮農會（農金資訊所屬會員）'],
  ['908', '通霄鎮農會（農金資訊所屬會員）'],
  ['909', '苑裡鎮農會（農金資訊所屬會員）'],
  ['912', '冬山鄉農會（農金資訊所屬會員）'],
  ['913', '後龍鎮農會（農金資訊所屬會員）'],
  ['914', '卓蘭鎮農會（農金資訊所屬會員）'],
  ['915', '西湖鄉農會（農金資訊所屬會員）'],
  ['916', '草屯鎮農會（農金資訊所屬會員）'],
  ['917', '公館鄉農會（農金資訊所屬會員）'],
  ['918', '銅鑼鄉農會（農金資訊所屬會員）'],
  ['919', '三義鄉農會（農金資訊所屬會員）'],
  ['920', '造橋鄉農會（農金資訊所屬會員）'],
  ['921', '南庄鄉農會（農金資訊所屬會員）'],
  ['922', '臺南市臺南地區農會（農金資訊所屬會員）'],
  ['923', '獅潭鄉農會（農金資訊所屬會員）'],
  ['924', '頭屋鄉農會（農金資訊所屬會員）'],
  ['925', '三灣鄉農會（農金資訊所屬會員）'],
  ['926', '苗栗縣大湖地區農會（農金資訊所屬會員）'],
  ['928', '板橋區農會（農金資訊所屬會員）'],
  ['929', '關西鎮農會（農金資訊所屬會員）'],
  ['930', '新埔鎮農會（農金資訊所屬會員）'],
  ['931', '竹北市農會（農金資訊所屬會員）'],
  ['932', '湖口鄉農會（農金資訊所屬會員）'],
  ['933', '芎林鄉農會（農金資訊所屬會員）'],
  ['934', '寶山鄉農會（農金資訊所屬會員）'],
  ['935', '峨眉鄉農會（農金資訊所屬會員）'],
  ['936', '北埔鄉農會（農金資訊所屬會員）'],
  ['937', '竹東地區農會（農金資訊所屬會員）'],
  ['938', '橫山地區農會（農金資訊所屬會員）'],
  ['939', '新豐鄉農會（農金資訊所屬會員）'],
  ['940', '新竹市農會信用部（農金資訊所屬會員）'],
  ['953', '田尾鄉農會（農金資訊所屬會員）'],
  ['984', '北投區農會（農金資訊所屬會員）'],
  ['985', '士林區農會（農金資訊所屬會員）'],
  ['986', '內湖區農會（農金資訊所屬會員）'],
  ['987', '南港區農會（農金資訊所屬會員）'],
  ['988', '木柵區農會（農金資訊所屬會員）'],
  ['989', '景美區農會（農金資訊所屬會員）'],
  ['612', '南農中心所屬會員'],
  ['613', '南農中心所屬會員'],
  ['614', '南農中心所屬會員'],
  ['616', '南農中心所屬會員'],
  ['617', '南農中心所屬會員'],
  ['618', '南農中心所屬會員'],
  ['619', '南農中心所屬會員'],
  ['620', '南農中心所屬會員'],
  ['621', '南農中心所屬會員'],
  ['622', '南農中心所屬會員'],
  ['624', '南農中心所屬會員'],
  ['627', '南農中心所屬會員'],
  ['952', '南農中心所屬會員'],
  ['020', '日商瑞穗銀行台北分行'],
  ['022', '美國銀行台北分行'],
  ['023', '泰國盤谷銀行台北分行'],
  ['025', '菲律賓首都銀行台北分行'],
  ['029', '新加坡商大華銀行台北分行'],
  ['030', '美商道富銀行台北分行'],
  ['037', '法商法國興業銀行台北分行'],
  ['039', '澳商澳盛銀行台北分行'],
  ['072', '德商德意志銀行台北分行'],
  ['075', '香港商東亞銀行台北分行'],
  ['076', '美商摩根大通銀行台北分行'],
  ['082', '法國巴黎銀行台北分行'],
  ['085', '新加坡商新加坡華僑銀行台北分行'],
  ['086', '法商東方匯理銀行台北分行'],
  ['092', '瑞士商瑞士銀行台北分行'],
  ['093', '荷商安智銀行台北分行'],
  ['098', '日商三菱日聯銀行台北分行'],
  ['321', '日商三井住友銀行台北分行'],
  ['326', '西班牙商西班牙對外銀行臺北分行'],
  ['329', '印尼商印尼人民銀行台北分行'],
  ['330', '韓商韓亞銀行台北分行'],
  ['380', '大陸商中國銀行臺北分行'],
  ['381', '大陸商交通銀行臺北分行'],
  ['382', '大陸商中國建設銀行臺北分行'],
  ['060', '兆豐票券金融股份有限公司'],
  ['061', '中華票券金融股份有限公司'],
  ['062', '國際票券金融股份有限公司'],
  ['066', '萬通票券金融股份有限公司'],
  ['372', '大慶票券金融股份有限公司'],
  ['995', '關貿網路股份有限公司'],
  ['996', '財政部國庫署'],
  ['700', '中華郵政股份有限公司'],
];

/**
 * Helper function to get bank name by code
 * @param {string} code - The bank code to look up
 * @return {string|null} The bank name or null if not found
 */
const getBankNameByCode = (code) => {
  const bank = banks.find(bank => bank[0] === code);
  return bank ? bank[1] : null;
};

/**
 * Helper function to get all banks as objects with code and name properties
 * @return {Array<{code: string, name: string}>} Array of bank objects
 */
const getBanksAsObjects = () => {
  return banks.map(([code, name]) => ({ code, name }));
};

export { banks, getBankNameByCode, getBanksAsObjects };
